export default "<img [src]=\"API + path\" alt=\"capture\" width=\"400px\" height=\"400px\" />\r\n";